/**
 * One QueryClient for the whole app.
 *
 * HR data changes on human timescales, so a 30 s staleTime removes almost all
 * refetching without anyone ever seeing a stale number that matters. Window-focus
 * refetching is off: this is a tool people leave open in a background tab all day,
 * and a refetch storm on every tab switch buys nothing.
 */
import { QueryClient } from "@tanstack/react-query";

export const STALE_TIME_MS = 30_000;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: STALE_TIME_MS,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // A mutation that failed may have already been applied server-side;
        // retrying it automatically risks a duplicate approval or claim.
        retry: 0,
      },
    },
  });
}

/** The instance the app mounts. Tests build their own with {@link createQueryClient}. */
export const queryClient = createQueryClient();
